import { PayloadAction } from '@reduxjs/toolkit';

import { ConditionAddress, conditionGroupChildenKey, DesignState } from 'editor/src/store/design/types';

import getConditionChildrenKey from './getConditionChildrenKey';
import getConditionParentKeys from './getConditionParentKeys';

const deleteConditionReducer = (state: DesignState, action: PayloadAction<ConditionAddress>) => {
  const address = action.payload;
  const { spreadIndex, conditionId } = address;
  const conditionGroup = state.designData?.spreads[spreadIndex]?.conditionGroup;
  if (!conditionGroup) {
    return;
  }

  const condition = conditionGroup.conditions[conditionId];
  const parentKeys = getConditionParentKeys(conditionGroup, conditionId);

  const topLevelChildren = conditionGroup.children[conditionGroupChildenKey];

  condition.options.forEach((value) => {
    const childrenKey = getConditionChildrenKey(condition.id, value.id);
    const children = conditionGroup.children[childrenKey];
    children.forEach((child) => {
      if (child.type === 'condition') {
        const childCondition = conditionGroup.conditions[child.id];
        childCondition.parent = undefined;
        if (!topLevelChildren.find((tChild) => tChild.type === 'condition' && tChild.id === child.id)) {
          topLevelChildren.push(child);
        }
      } else {
        const element = state.designData?.spreads[spreadIndex].pages[0].groups.media?.find(
          (element) => element.uuid === child.id,
        );
        if (
          element &&
          !element.personalizationLocked &&
          !topLevelChildren.find((tChild) => tChild.type !== 'condition' && tChild.id === child.id)
        ) {
          topLevelChildren.push(child);
        }
      }
    });
    delete conditionGroup.children[childrenKey];
  });
  delete conditionGroup.conditions[condition.id];

  // Texts that varied with this condition have nothing left to follow. Left in
  // place they read as "follows <uuid>" in VaryingTextsSection with the switch
  // stuck off — the row is shown as owned by another picklist, so it can never
  // be reassigned. Design-scoped picklists drive texts on any spread, so this
  // is a whole-design scan, not a spread-local one.
  state.designData?.spreads.forEach((spread) => {
    spread.pages[0]?.groups.media?.forEach((element) => {
      if (element.type === 'text' && element.extra.textVariants?.conditionId === conditionId) {
        element.extra.textVariants = undefined;
      }
    });
  });

  if (parentKeys.length) {
    parentKeys.forEach((parentKey) => {
      conditionGroup.children[parentKey] = conditionGroup.children[parentKey].filter(
        (element) => element.type !== 'condition' || element.id !== conditionId,
      );
    });
  }
};

export default deleteConditionReducer;
